import Icon from 'vue-awesome/components/Icon'

Icon.register({
  local_offer_sharp: {
    paths: [
      {
        d: 'M22.83 12.99L11.83 2H2v9.83l10.99 10.99 9.84-9.83zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z'
      }
    ],
    width: '24',
    height: '24'
  }
})
